import styled from 'styled-components';

const HandleSection = styled.div`
  padding-left: 12px;
  margin: 20px -8px 0;
  display: flex;
  flex-wrap: wrap;
`

export default HandleSection;